// Bulk-label PDF printer. POSTs a list of order ids to /api/orders/labels.pdf
// and triggers a single multi-page PDF download (one 4×6 label per page).

import { API } from "@/lib/api";

const TOKEN_KEY = "pr_token";

/**
 * Fire POST /api/orders/labels.pdf, then download the resulting PDF.
 * @param {Array<{id:string}>} orders  Orders to print labels for.
 * @returns {Promise<{count:number, filename:string}|null>} or null on no-op.
 */
export async function printBulkLabels(orders) {
  const ids = (orders || []).map((o) => o.id).filter(Boolean);
  if (!ids.length) return null;
  const token = localStorage.getItem(TOKEN_KEY) || "";
  const resp = await fetch(`${API}/orders/labels.pdf`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ order_ids: ids }),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(text || `HTTP ${resp.status}`);
  }
  const blob = await resp.blob();
  const count = Number(resp.headers.get("X-Labels-Count")) || ids.length;
  const stamp = new Date().toISOString().slice(0, 10);
  const filename = `labels-${count}-${stamp}.pdf`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return { count, filename };
}
